import { Button } from "components/common";
import useBottomSheet from "hooks/common/useBottomSheet";
import { useEffect, useRef, useState } from "react";
import { BJFaceViolation } from "types/models/bjFaceViolation";

const PrimeBJRestriction = () => {
    const { close } = useBottomSheet();
    const [leftTime, setLeftTime] = useState(0);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const timerStarted = useRef(false);

    useEffect(() => {
        PrimeDataManager.getFaceViolationInfo().then((bjFaceViolationInfo: BJFaceViolation) => {
            if(!bjFaceViolationInfo) {
                close('PrimeBJRestriction');
                return;
            }
            const lastUpdateAtTs = bjFaceViolationInfo.lastUpdatedAt.getTime();
            const timeDiff = lastUpdateAtTs + 1000 * 60 * 60 - BUtil.getCachedServerTime();
            setLeftTime(timeDiff);
    
            clearInterval(timerRef.current as NodeJS.Timeout);
            timerRef.current = setInterval(() => {
                setLeftTime((prev) => prev - 1000);
                timerStarted.current = true;
            }, 1000);
        });

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (leftTime <= 0 && timerStarted.current) {
            close('PrimeBJRestriction');
        }
    }, [leftTime, close]);

    return (
        <div className="flex flex-col justify-center items-center">
            <div className="typography-title-md text-center">{brsc.sheet_title_accumulated_warn}</div>
            <div className="typography-body-sm text-center mt-2 text-base-txt-secondary">{brsc.sheet_desc_call_restrict}</div>
            <div className="flex w-full  rounded-lg justify-center items-center typography-title-xl bg-base-bg-strong py-6 my-4">
                {leftTime > 0 ? TimeUtil.getDateTimemmss(leftTime) : ''}
            </div>
            <div className="flex gap-2 w-full">
                <Button onClick={() => Device.openSupportCenter(myinfo.fbUid)} className="flex-none px-5" style={{ text: brsc.restrictions_contact, color: 'btn-bg-secondary', borderRadius: 'full', type: 'outline' }} />
                <Button onClick={() => close('PrimeBJRestriction')} className="flex" style={{ text: brsc.confirm, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'full' }} />
            </div>
        </div>
    );
};

export default PrimeBJRestriction;